var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayLocate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    transform: "translate(-732 -523)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 383,
    height: 852,
    transform: "translate(-46 -393)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26 -60C-26 -65.5229 -21.5228 -70 -16 -70H307C312.523 -70 317 -65.5228 317 -60V191C317 196.523 312.523 201 307 201H-16C-21.5228 201 -26 196.523 -26 191V-60Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -60,
    width: 323,
    height: 91,
    rx: 5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0737 1.40545C9.42534 0.874556 8.66721 0.494172 7.85402 0.291738C7.04083 0.0893047 6.19285 0.0698677 5.37124 0.234829C4.31482 0.451417 3.34292 0.967112 2.57132 1.72048C1.79972 2.47386 1.26095 3.43315 1.01917 4.48409C0.777396 5.53504 0.842814 6.63333 1.20763 7.64814C1.57245 8.66295 2.22129 9.55151 3.07686 10.208C4.05369 10.9229 4.88539 11.8174 5.52749 12.8436L5.96499 13.5711C6.02055 13.6635 6.09908 13.74 6.19293 13.793C6.28679 13.8461 6.39278 13.874 6.50061 13.874C6.60844 13.874 6.71443 13.8461 6.80829 13.793C6.90214 13.74 6.98067 13.6635 7.03623 13.5711L7.45561 12.8723C8.01474 11.8894 8.77713 11.0371 9.69186 10.3723C10.4091 9.87885 11.0019 9.22545 11.4234 8.46367C11.8449 7.70189 12.0836 6.85258 12.1207 5.98275C12.1578 5.11292 11.9922 4.24637 11.6371 3.45148C11.282 2.65658 10.747 1.95508 10.0744 1.40233L10.0737 1.40545ZM6.49998 8.24984C6.00553 8.24984 5.52218 8.10321 5.11106 7.82851C4.69994 7.55381 4.37951 7.16336 4.19029 6.70654C4.00107 6.24973 3.95156 5.74706 4.04802 5.26211C4.14449 4.77715 4.38259 4.3317 4.73222 3.98206C5.08185 3.63243 5.52731 3.39433 6.01226 3.29787C6.49721 3.20141 6.99988 3.25091 7.45669 3.44013C7.91351 3.62935 8.30395 3.94978 8.57866 4.36091C8.85336 4.77203 8.99998 5.25538 8.99998 5.74983C8.99998 6.41288 8.73659 7.04876 8.26775 7.5176C7.79891 7.98644 7.16303 8.24984 6.49998 8.24984Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_1",
    x: -66,
    y: -413,
    width: 423,
    height: 892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    fill: "white",
    transform: "translate(-732 -523)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayLocate);
export default __webpack_public_path__ + "static/media/gray-locate.38febac4ddd18edeb873c6ab27771171.svg";
export { ForwardRef as ReactComponent };